import { classes } from '../base/classes.helpers';
import { iconInlineBase, iconInlineSprinkles } from './iconInline.css';

/**
 * Use an SVG icon in your UI. See `generateMaskIcon.tsx` on how to create icons.
 *
 * This variant is for inline icons, such as in a link. It has to be `display: inline;` otherwise line breaks will be messed up.
 */
export const iconInline = ({
	icon,
	...props
}: Parameters<typeof iconInlineSprinkles>[0] & { icon: string }) => {
	return classes(iconInlineBase, iconInlineSprinkles(props), icon);
};
